import { FC } from 'react';
import classNames from 'classnames';

import styles from './RadioGroupItemIndicator.module.css';

export type RadioGroupItemIndicatorProps = {
  /** Спиннер вместо точки внутри кольца, например пока опция ещё подгружается. */
  loading?: boolean;
  className?: string;
};

/** Визуальный индикатор варианта — кольцо с точкой или спиннер загрузки. */
const RadioGroupItemIndicator: FC<RadioGroupItemIndicatorProps> = ({ loading = false, className }) => (
  <span className={classNames(styles.indicator, className)}>
    <svg
      className={styles.graphic}
      viewBox="0 0 24 24"
      aria-hidden="true">
      <circle
        className={styles.disc}
        cx="12"
        cy="12"
        r="11"
      />

      {!loading && (
        <circle
          className={styles.dot}
          cx="12"
          cy="12"
          r="8"
        />
      )}
    </svg>

    {loading && <span className={styles.spinner} />}
  </span>
);

export default RadioGroupItemIndicator;
